module.exports = __webpack_public_path__ + "static/media/series_meeting.471d7b05.svg";